import { render, staticRenderFns } from "./JournalView.vue?vue&type=template&id=352f0dae&scoped=true&"
import script from "./JournalView.vue?vue&type=script&lang=js&"
export * from "./JournalView.vue?vue&type=script&lang=js&"
import style0 from "./JournalView.vue?vue&type=style&index=0&id=352f0dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f0dae",
  null
  
)

export default component.exports